import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';


import { PrivateFinancingActionTypes , PrivateFinancingActions, LoadPrivateFinancingsSuccess} from '../actions/private-financing.actions';
import { SummaryPrivateFinancingModel } from '../../models/summary-private-financing.model';


export interface PrivateFinancingState {
  items: SummaryPrivateFinancingModel[];
  total: number;
  res: PaginableResponseModel<SummaryPrivateFinancingModel>;
  selected: SingleResponseModel<SummaryPrivateFinancingModel> | null;
  loading: boolean;
  error: any
}


export const initalState: PrivateFinancingState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function PrivateFinancingReducer(
  state = initalState,
  action: PrivateFinancingActions
): PrivateFinancingState {

  switch (action.type) {
    case PrivateFinancingActionTypes.LoadPrivateFinancings:
      return { ...state, loading: true, error: null };

    case PrivateFinancingActionTypes.LoadPrivateFinancingsSuccess:
      const { items, total } = (action as LoadPrivateFinancingsSuccess).payload;
           return {
             ...state,
             loading: false,
             error: null,
             items: items,
             total: total,
           };
    case PrivateFinancingActionTypes.LoadPrivateFinancingsFailure:
      return{ ...state, loading: false, error: action.payload.error };


    case PrivateFinancingActionTypes.LoadPrivateFinancingSuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
